export default __webpack_public_path__ + "static/media/256.5e6ed3db.gif";